import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from '@/components/Dashboard'
import Login from '@/components/Login'
import SignUp from '@/components/SignUp'
import Reset from '@/components/Reset'
import Admin from '@/components/Admin'
import Home from '@/components/admin/Home'

import firebase from 'firebase'
import db from '../main.js'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '*',
      redirect: '/login'
    },
    {
      path: '/',
      redirect: '/dashboard'
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/reset-password',
      name: 'Reset',
      component: Reset
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/files/:client',
      name: 'Client',
      component: Dashboard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/files/:client/:folder',
      name: 'Folder',
      component: Dashboard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/files/:client/:folder/:file',
      name: 'File',
      component: Dashboard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/admin',
      name: 'Admin',
      component: Admin,
      redirect: '/admin/home',
      children: [
        {
          path: '/admin/home',
          name: 'Home',
          component: Home
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  let currentUser = firebase.auth().currentUser;

  let requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  console.log(currentUser)
  if (requiresAuth && !currentUser) next('login')

  else next()
})

export default router
